export const glLockUnlockOperations = () => ({
  lockByDateAndFy: 'lockByDateAndFy',
  unlockByIds: 'unlockByIds',
  lockByIds: 'lockByIds',
});

export default {
  glLockUnlockOperations,
};
